<script setup lang="ts">
    import { type SmallCardTyping } from '@/typings/widget';

    defineProps<{
        card: SmallCardTyping
        selected?: boolean
    }>();

    const hover = ref(false);
</script>

<template>
    <div
        :class="{
            'small-card--hover': hover,
            'small-card--selected': selected,
        }"
        class="small-card"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
    >
        <img
            v-if="card?.image"
            :src="(hover && card.hoverImage) || selected ? card.hoverImage : card.image"
            class="small-card__image"
        >
        <span
            v-if="card?.title"
            class="small-card__title"
        >
            {{ card.title }}
        </span>
        <span
            v-if="card?.subtitle"
            class="small-card__subtitle"
        >
            {{ card.subtitle }}
        </span>
    </div>
</template>

<style lang="scss" scoped>
.small-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-03);
    border: 1px solid var(--color-white);
    border-radius: var(--border-radius-sm);
    background: rgb( 255 255 255 / .4);
    block-size: 156px;
    cursor: pointer;
    inline-size: 100%;

    @include min-width(md) {
        block-size: 204px;
    }

    &--hover,
    &--selected {
        border-color: var(--border-primary);
    }

    &__title,
    &__subtitle {
        font-weight: var(--font-weight-medium);
        line-height: 120%;
        text-align: center;
    }

    &__title {
        font-family: var(--font-secondary);
        font-size: var(--font-h3);
    }

    &__subtitle {
        font-size: var(--font-h4);
    }

    &__image {
        block-size: 100px;
        object-fit: contain;
    }
}
</style>
